module.exports = __webpack_public_path__ + "static/media/feature-3-assessment.3f5e00fc.png";